import http from '../../../Services/api.laravel.http';

export const HomeService = {
    getCounts: (filter) => http.post('/admin/dashboard', filter),
};
